<template>
  <b-modal
    ref="modal"
    id="modal-danfe-email"
    hide-header
    hide-footer
    body-class="p-0 overflow-hidden"
    content-class="border-0 shadow-lg"
    centered
    size="lg"
    @shown="onModalShown"
  >
    <div class="modal-header-premium p-3 d-flex align-items-center" style="background: linear-gradient(135deg, #20a8d8 0%, #1783ae 100%) !important;">
      <div class="header-icon-wrapper mr-3 bg-white-10">
        <i class="fa fa-envelope-open text-white"></i>
      </div>
      <div>
        <h5 class="mb-0 font-weight-bold text-white">Enviar DANFE e XML por E-mail</h5>
        <small class="text-white opacity-75">Destinatário, assunto e anexos carregados automaticamente a partir da NF-e</small>
      </div>
      <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="hide">
        <i class="fa fa-times fa-lg"></i>
      </b-button>
    </div>

    <b-overlay :show="carregando || enviando" rounded="sm" opacity="0.7">
      <div class="p-4 bg-white">
        <div class="modal-info-bar mb-4 bg-light border shadow-sm p-3 rounded" v-if="resumoNfe">
          <b-row align-v="center">
            <b-col md="6">
              <small class="modal-label-premium">Destinatário</small>
              <h5 class="mb-0 font-weight-bold text-dark">{{ resumoNfe.TX_RAZAO_SOCIAL_DEST || 'Não informado' }}</h5>
            </b-col>
            <b-col md="3" class="border-left">
              <small class="modal-label-premium">NF-e / Série</small>
              <h5 class="mb-0 font-weight-bold text-primary">{{ resumoNfe.TX_NUM_NFE || resumoNfe.ID }}</h5>
              <small class="text-muted font-weight-bold">Série {{ resumoNfe.ID_SERIE || '-' }}</small>
            </b-col>
            <b-col md="3" class="border-left text-right">
              <small class="modal-label-premium">Anexos</small>
              <h5 class="mb-0 font-weight-bold text-success">{{ anexosProntos }}</h5>
              <small class="text-muted font-weight-bold">prontos para envio</small>
            </b-col>
          </b-row>
        </div>

        <b-alert v-if="erroCarregamento" show variant="danger" class="mb-4 rounded">
          {{ erroCarregamento }}
        </b-alert>

        <b-form @submit.prevent="onSubmit">
          <div class="modal-section-title mb-3">
            <i class="fa fa-paperclip mr-2 text-primary"></i> Anexos do E-mail
          </div>

          <b-row class="mb-4">
            <b-col md="6" v-for="anexo in anexos" :key="anexo.nome" class="mb-3 mb-md-0">
              <div class="attachment-card-premium h-100" :class="{ 'attachment-card-ready': anexo.pronto }">
                <div class="d-flex align-items-center">
                  <div class="attachment-icon mr-3">
                    <i :class="anexo.tipo === 'XML' ? 'fa fa-file-code-o' : 'fa fa-file-pdf-o'"></i>
                  </div>
                  <div>
                    <small class="modal-label-premium mb-1">{{ anexo.tipo }}</small>
                    <div class="font-weight-bold text-dark">{{ anexo.nome }}</div>
                    <small :class="anexo.pronto ? 'text-success font-weight-bold' : 'text-danger font-weight-bold'">
                      {{ anexo.pronto ? 'Anexo carregado' : 'Anexo indisponível' }}
                    </small>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>

          <div class="modal-section-title mb-3">
            <i class="fa fa-users mr-2 text-primary"></i> Destinatários
          </div>

          <b-row>
            <b-col md="12">
              <b-form-group label="Destinatário principal" label-class="modal-label-premium">
                <b-form-input ref="emailPrincipal" v-model="form.emailPrincipal" placeholder="email@exemplo.com" class="rounded-pill shadow-xs" />
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group label="Adicionar mais destinatários" label-class="modal-label-premium">
                <b-form-input ref="destinatariosAdicionais" v-model="form.destinatariosAdicionais" placeholder="email1@exemplo.com; email2@exemplo.com" class="rounded-pill shadow-xs" />
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group label="Com cópia (CC)" label-class="modal-label-premium">
                <b-form-input v-model="form.cc" placeholder="email1@exemplo.com; email2@exemplo.com" class="rounded-pill shadow-xs" />
              </b-form-group>
            </b-col>
          </b-row>

          <div class="modal-section-title mb-3">
            <i class="fa fa-commenting-o mr-2 text-primary"></i> Conteúdo do E-mail
          </div>

          <b-row>
            <b-col md="12">
              <b-form-group label="Remetente" label-class="modal-label-premium">
                <b-form-input :value="form.remetente" readonly class="rounded-pill shadow-xs bg-light border-0" />
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group label="Assunto" label-class="modal-label-premium">
                <b-form-input v-model="form.assunto" readonly class="rounded-pill shadow-xs bg-light border-0" />
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group label="Corpo do e-mail" label-class="modal-label-premium">
                <b-form-textarea v-model="form.corpo" rows="6" readonly class="rounded-lg shadow-xs border-0 bg-light" />
              </b-form-group>
            </b-col>
          </b-row>

          <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-between align-items-center mt-4 rounded-bottom">
            <div class="text-muted small font-weight-bold">
              O Node fará o envio com os anexos DANFE e XML já preparados.
            </div>
            <div>
              <b-button variant="soft-danger" pill class="px-4 font-weight-bold mr-2" @click="hide">
                CANCELAR
              </b-button>
              <b-button variant="success" pill class="px-5 font-weight-bold shadow-sm" type="submit" :disabled="!podeEnviar">
                <i class="fa fa-paper-plane mr-1"></i> ENVIAR E-MAIL
              </b-button>
            </div>
          </div>
        </b-form>
      </div>
    </b-overlay>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      nfe: null,
      resumoNfe: null,
      anexos: [],
      carregando: false,
      enviando: false,
      erroCarregamento: '',
      form: {
        emailPrincipal: '',
        destinatariosAdicionais: '',
        cc: '',
        assunto: '',
        corpo: '',
        remetente: ''
      }
    }
  },
  computed: {
    anexosProntos() {
      return this.anexos.filter(anexo => anexo.pronto).length
    },
    podeEnviar() {
      return !this.carregando && !this.enviando && !this.erroCarregamento && this.anexos.length > 0 && this.anexosProntos === this.anexos.length && !!this.nfe?.ID
    }
  },
  methods: {
    show() { this.$refs.modal.show() },
    hide() { this.$refs.modal.hide() },
    limparEstado() {
      this.resumoNfe = null
      this.anexos = []
      this.carregando = false
      this.enviando = false
      this.erroCarregamento = ''
      this.form = {
        emailPrincipal: '',
        destinatariosAdicionais: '',
        cc: '',
        assunto: '',
        corpo: '',
        remetente: ''
      }
    },
    async openFor(nfe) {
      if (!nfe?.ID) {
        this.$bvToast.toast('NF-e inválida para envio de e-mail', { title: 'Erro', variant: 'danger' })
        return
      }

      this.nfe = { ID: nfe.ID }
      this.limparEstado()
      this.nfe = { ID: nfe.ID }
      this.show()
      await this.carregarConfiguracao()
    },
    async carregarConfiguracao() {
      if (!this.nfe?.ID) return

      try {
        this.carregando = true
        this.erroCarregamento = ''

        const response = await this.$http.post('/api/protected/nfe/danfe/email-config', { nfeId: this.nfe.ID })
        const data = response.data || {}

        this.resumoNfe = data.nfe || null
        this.anexos = data.anexos || []
        this.form.emailPrincipal = data.email?.destinatarioPrincipal || ''
        this.form.assunto = data.email?.assunto || ''
        this.form.corpo = data.email?.corpo || ''
        this.form.remetente = data.email?.remetente || ''
      } catch (err) {
        this.erroCarregamento = err?.response?.data?.erro || err?.response?.data?.message || (typeof err?.response?.data === 'string' ? err.response.data : null) || err?.message || 'Não foi possível preparar o e-mail da NF-e.'
      } finally {
        this.carregando = false
      }
    },
    onModalShown() {
      this.$nextTick(() => {
        if (this.$refs.emailPrincipal) {
          this.$refs.emailPrincipal.focus()
        } else if (this.$refs.destinatariosAdicionais) {
          this.$refs.destinatariosAdicionais.focus()
        }
      })
    },
    async onSubmit() {
      if (!this.podeEnviar) return

      try {
        this.enviando = true

        const payload = {
          nfeId: this.nfe.ID,
          emailPrincipal: this.form.emailPrincipal,
          destinatariosAdicionais: this.form.destinatariosAdicionais,
          cc: this.form.cc
        }

        await this.$store.dispatch('nfe/ENVIAR_DANFE', payload)
        this.$emit('sent', payload)
        this.$bvToast.toast('E-mail enviado com sucesso', { title: 'Sucesso', variant: 'success', solid: true })
        this.hide()
      } catch (err) {
        const mensagem = err?.response?.data?.erro || err?.response?.data?.message || (typeof err?.response?.data === 'string' ? err.response.data : null) || err?.message || 'Falha ao enviar o e-mail da NF-e.'
        this.$bvToast.toast(mensagem, { title: 'Erro', variant: 'danger', solid: true })
      } finally {
        this.enviando = false
      }
    }
  }
}
</script>

<style scoped>
.modal-header-premium {
  border-bottom: none;
}

.header-icon-wrapper {
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-size: 1.3rem;
}

.bg-white-10 {
  background-color: rgba(255, 255, 255, 0.15) !important;
}

.modal-section-title {
  font-size: 0.9rem;
  font-weight: 700;
  color: #2d3748;
  border-bottom: 2px solid #edf2f7;
  padding-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.modal-label-premium {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #6c757d;
  margin-bottom: 0.4rem;
  display: block;
}

.shadow-xs {
  box-shadow: 0 2px 4px rgba(0,0,0,0.05) !important;
}

.attachment-card-premium {
  border: 1px solid #e9ecef;
  border-radius: 14px;
  padding: 1rem;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbfd 100%);
  box-shadow: 0 2px 6px rgba(0,0,0,0.04);
}

.attachment-card-ready {
  border-color: rgba(84, 180, 53, 0.35);
  box-shadow: 0 6px 16px rgba(84, 180, 53, 0.12);
}

.attachment-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(32, 168, 216, 0.12);
  color: #1783ae;
  font-size: 1.2rem;
}

.btn-soft-danger {
  background-color: rgba(248, 108, 107, 0.1);
  color: #f86c6b;
  border: none;
}

.btn-soft-danger:hover {
  background-color: #f86c6b;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/views/faturamento/nfe/partials/DanfeEmailModal.vue